import React from 'react';

export default function (prevData, data, key) {
    const prevValue = (prevData || {})[key];
    const value = data[key];
    if (prevValue === value) {
        return value;
    } else {
        return (
            <div style={{ color: '#F00' }}>
                {value}
                <del style={{ marginLeft: 16 }}>{prevValue}</del>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Components/compareFn.js